<div class="container">
    <div class="d-flex align-items-center mt-3">
        <h1 mat-dialog-title>Edit Note</h1>
    </div>
    <div class="row my-3">
        <div mat-dialog-content [formGroup]="form">
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Subject</mat-label>
                    <input matInput formControlName="_subject">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Comment</mat-label>
                    <textarea matInput placeholder="Note" formControlName="_comment"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelEditNote()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button" (click)="submitNote()">
                <mat-icon>check</mat-icon>
                Submit Note
            </button>
        </div>
    </div>
</div>